import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';

class DetailedMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatData(selectedMessage) {
    return VerticalLabelList.toList({
      ID: selectedMessage._id,
      'Customer ID': selectedMessage.smsTemplate.customerId,
      Message: selectedMessage.smsTemplate.message,
      'Service Offering ID': selectedMessage.smsTemplate.serviceOfferingId,
      'Message Type': selectedMessage.smsTemplate.messageType,
      Status: selectedMessage.status.status,
      'Status Reason': selectedMessage.status.reason,
      Timestamp: selectedMessage.timestamp ? moment(selectedMessage.timestamp).utc().format() : '',
    });
  }

  render() {
    const { selectedMessage, } = this.props;
    const formattedData = this.formatData(selectedMessage);
    return (
      <div>
        <div>
          <FieldSet title="Message Summary" style={{ maxHeight: '300px', }}>
            <VerticalLabelList items={formattedData} />
          </FieldSet>
        </div>
      </div>
    );
  }
}

DetailedMessage.defaultProps = {};

DetailedMessage.propTypes = {
  selectedMessage: PropTypes.instanceOf(Object).isRequired,
};

export default DetailedMessage;
